<template>
  <v-container text-md-center justify-center>
    <v-row>
      <v-col class="justify-center">
        <user-detail-compornent :is-login-user="isLoginUser" :friend-status="friendStatus">
          <template #editUserBtn v-if="isLoginUser">
            <v-btn color="primary" @click.stop="openModal()">
              <v-icon> mdi-pencil-outline </v-icon>
              <span> ユーザー情報を編集する </span>
            </v-btn>
          </template>
          <template #friendBtn v-else>
            <v-btn v-if="friendStatus === 0" color="primary" @click="apply"> 友達申請 </v-btn>
            <v-btn v-else-if="friendStatus === 1" color="primary" @click="discontinue"> 申請中 </v-btn>
            <v-btn v-else-if="friendStatus === 2" color="primary" @click="approveOrReject"> 承認待ち </v-btn>
            <v-btn v-else-if="friendStatus === 3" color="primary" @click="release"> 友達です </v-btn>
          </template>
        </user-detail-compornent>
      </v-col>
    </v-row>
    <v-divider class="my-3" />
    <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
      <v-tab :disabled="tabItem.disabled" v-for="(tabItem, index) in tabItems" :key="'tab-' + index"> {{ tabItem.title }} </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(tabItem, index) in tabItems" :key="'tabItem-' + index">
        <keep-alive>
          <component :is="tabItem.component" v-bind="tabItem.props" :is-login-user="isLoginUser" />
        </keep-alive>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import JobContinueCalendarComponet from "../components/JobContinueCalendar";
import MyJobPerformanceCompornent from "../components/MyJobPerformanceBarChartCard";
import UserDetailCompornent from "../components/UserDetail";
import UserRecordCompornent from "../components/UserRecord";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    UserDetailCompornent,
    UserRecordCompornent,
    MyJobPerformanceCompornent,
    JobContinueCalendarComponet
  },

  computed: {
    ...mapGetters(["friend/loginUserFriends", "user/otherUser"]),
    friendStatus() {
      let friendStatus = 0;
      this["friend/loginUserFriends"].forEach((friend) => {
        if (friend.userId === this.$route.params.user_id) {
          friendStatus = friend.friendStatus;
        }
      })
      return friendStatus;
    },
    otherUserName() { return this["user/otherUser"].userName; }
  },

  watch: {
    // パラメータの変更を検知する
    $route(){
      // userIdパラメータの有無でマイページか他ユーザーページか判定する.
      if (this.$route.params.user_id) {
        this.isLoginUser = false
        this["friend/fetchOtherUserFriends"](this.$route.params.user_id);
        this["job/fetchOtherUserJobs"](this.$route.params.user_id);
        this["user/fetchOtherUser"](this.$route.params.user_id);
      } else {
        this.isLoginUser = true;
        this.tabItems.push({ component: JobContinueCalendarComponet, title: "ジョブカレンダー" })
      }
    }
  },

  created() {
    this.closeCommentModal();
    // userIdパラメータの有無でマイページか他ユーザーページか判定する.
    if (this.$route.params.user_id) {
      this.isLoginUser = false
      this["friend/fetchOtherUserFriends"](this.$route.params.user_id);
      this["job/fetchOtherUserJobs"](this.$route.params.user_id);
      this["user/fetchOtherUser"](this.$route.params.user_id);
    } else {
      this.isLoginUser = true;
      this.tabItems.push({ component: JobContinueCalendarComponet, title: "ジョブカレンダー" })
    }
  },

  data() {
    return {
      tab: null,
      tabItems: [
        { component: UserRecordCompornent, title: "ユーザーレコード" },
        // { component: MyJobPerformanceCompornent, title: "実績まとめ" },
      ],
      isLoginUser: true
    };
  },

  methods: {
    ...mapActions([
      "closeCommentModal",
      "setLoading",
      "toggleEditUserModal",
      "friend/apply",
      "friend/approve",
      "friend/discontinue",
      "friend/fetchOtherUserFriends",
      "friend/reject",
      "friend/release",
      "job/fetchOtherUserJobs",
      "user/fetchOtherUser"
    ]),
    // 申請を行います.
    apply() { this["friend/apply"]( this["user/otherUser"] ); },
    // 友達申請を承認するか拒否します.
    approveOrReject() {
      if (confirm(this["user/otherUser"].userName + "さんからの友達申請を承認しますか？")) {
        this["friend/approve"]( this["user/otherUser"] );
      } else {
        this["friend/reject"]( this["user/otherUser"] );
      }
    },
    // 友達申請を中止します.
    discontinue() { this["friend/discontinue"]( this["user/otherUser"] ); },
    // 友達関係を解除します.
    release() { this["friend/release"]( this["user/otherUser"] ); },
    // ユーザー情報を編集するモーダルを開きます.
    openModal() { this.toggleEditUserModal(); },
  },
};
</script>
